import React from 'react'
import { Link } from 'react-router-dom'
import './App.css'

function App() {
  return (
    <div className="App">
      <div id="header">
        <img id="headerImage" src="cometa.png" alt="cometa.png"></img>
      </div>
      <div id="title">Cometa Utilitários Digitais</div>
      <div id="about">
        Somos uma empresa focada em construir utilitários digitais para
        facilitar a vida e poupar o tempo dos nossos clientes. Nosso foco é
        construir produtos de qualidade, capazes de auxiliar nosso cliente a
        realizar uma tarefa específica.
      </div>
      <div id="apps">
        <Link to="/poupe">
          <div>Poupe</div>
        </Link>
        <Link to="/rosary">
          <div>Rosary</div>
        </Link>
        <Link to="/mercychaplet">
          <div>Chaplet of Divine Mercy</div>
        </Link>
        <Link to="/cookbook">
          <div>CookBook</div>
        </Link>
        <Link to="/meds">
          <div>Meds</div>
        </Link>
      </div>
      <div id="contact">
        Entre em contato para tirar dúvidas, contribuir com sugestões ou
        encaminhar reclamações por email, em cometa.utd@gmail.com
        <div id="src">
          https://app-privacy-policy-generator.firebaseapp.com/
        </div>
      </div>
    </div>
  )
}

export default App
